class CustomImageSlider extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      var desktopview = $(this).data('desktopview');
      var mobileview = $(this).data('mobileview');
      var CustomSliderMedia = new Swiper(".custom-slider-media-info-"+ this.getAttribute("data-sectionid"), {
        spaceBetween: 16,
        slidesPerView: mobileview,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView:mobileview,
            spaceBetween: 16,
          },    
          660: {
            slidesPerView: mobileview + 0.5,
            spaceBetween: 30,
          },
          1025:{
            slidesPerView:desktopview - 0.7,
            spaceBetween: 46,
          },
          1200: {
            slidesPerView:desktopview,
            spaceBetween: 46,
          },
        },
        mousewheel: {
          forceToAxis: true
        },
      });
      $(this).css({"opacity":"1"});
    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}
customElements.define("custom-image-slider", CustomImageSlider);


class CustomProductSlider extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      this.el = this;

      var desktopview = $(this).data('desktopview');
      var mobileview = $(this).data('mobileview');
      var CustomSliderMedia = new Swiper(".custom-product-slider-"+ this.getAttribute("data-sectionid"), {
        spaceBetween: 15,
        slidesPerView: mobileview,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView:mobileview,
            spaceBetween: 15,
          },    
          768:{
            slidesPerView:mobileview + 1,
            spaceBetween: 15,
          },
          1025: {
            slidesPerView:desktopview - 1,
            spaceBetween: 15,
          },
          1300: {
            slidesPerView:desktopview,
            spaceBetween: 15,
          }
        },
        mousewheel: {
          forceToAxis: true
        },
      });
      $(this).css({"opacity":"1"});

        this.colorImages = this.el.querySelectorAll('.grid-product__color-image');
        if (this.colorImages.length) {
            this.swatches = this.el.querySelectorAll('.color-swatch--with-image');
            this.colorSwatchHovering();
        }
    }
 
    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }

   colorSwatchHovering() {
      this.swatches.forEach(swatch => {
        swatch.addEventListener('mouseenter', function() {
          this.setActiveColorImage(swatch);
        }.bind(this));
  
        swatch.addEventListener('touchstart', function(evt) {
          evt.preventDefault();
          this.setActiveColorImage(swatch);
        }.bind(this), {passive: true});
  
        swatch.addEventListener('mouseleave', function() {
          this.removeActiveColorImage(swatch);
        }.bind(this));
      });
    }
  
    setActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      const image = swatch.dataset.variantImage;

      this.colorImages.forEach(el => {
        el.classList.remove('is-active');
      });
  
      this.swatches.forEach(el => {
        el.classList.remove('is-active');
      });

      const imageEl = this.el.querySelector(`.grid-product__color-image--${id}`);
  
      imageEl.style.backgroundImage = 'url(' + image + ')';
      imageEl.classList.add('is-active');
      swatch.classList.add('is-active');

      const variantUrl = swatch.dataset.url;
      const gridItem = swatch.closest('.grid-item__link');
      gridItem.setAttribute('href', variantUrl);
    }
  
    removeActiveColorImage(swatch) {
      const id = swatch.dataset.variantId;
      this.el.querySelector(`.grid-product__color-image--${id}`).classList.remove('is-active');
    }
}
customElements.define("custom-product-slider", CustomProductSlider);

class CustomReviewsSlider extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(entries[0].target);

      var desktopview = $(this).data('desktopview');
      var mobileview = $(this).data('mobileview');
      var CustomSliderMedia = new Swiper(".custom-slider-media-info-"+ this.getAttribute("data-sectionid"), {
        spaceBetween: 10,
        slidesPerView: mobileview,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
            el: ".swiper-pagination",
            clickable: true,
        },
        breakpoints: {
          0: {
            slidesPerView:mobileview,
            spaceBetween: 10,
          },    
          768:{
            slidesPerView:desktopview,
            spaceBetween: 16,
          },
          1200: {
            slidesPerView:desktopview,
            spaceBetween: 30,
          },
        },
        mousewheel: {
          forceToAxis: true
        },
      });
      $(this).css({"opacity":"1"});
    }; 

    const observer = new IntersectionObserver(handleIntersection, {
      rootMargin: "0px 0px 300px 0px",
    });

    observer.observe(this);
  }
}
customElements.define("custom-reviews-slider", CustomReviewsSlider);

class FaqSection extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);
      $(".faq-questions-" + this.getAttribute("data-sectionid")).on(
        "click",
        function (e) {
          e.preventDefault();



            var $this = $(this);
            var $content = $this.next(".faq-inner-content");

            $content.addClass("stuck");
            setTimeout(function () {
              $content.removeClass("stuck");
            }, 500);

            if ($this.hasClass("accordion-active")) {
              // Already open → close it
              $this.removeClass("accordion-active");
              $content.css("height", 0);
            } else {
              // Close all others
              $(".faq-inner-title").removeClass("accordion-active");
              $(".faq-inner-content").css("height", 0);

              // Open this one
              $this.addClass("accordion-active");
              var height = $content.find("p").outerHeight();
              $content.css("height", height + "px");
            }
     

          // $this.next().slideToggle();
        }
      );
    };
    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: "0px 0px 400px 0px",
    }).observe(this);
  }
}
customElements.define("faq-section", FaqSection);